import React, { useState, useEffect } from "react";
import { format, subMonths } from "date-fns";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import ScrollContainer from "react-indiana-drag-scroll";
import { getBrandOptions } from "../../utils/constants";

function AccountManagementTracking() {
  let monthArray = [];
  let currDate = new Date().setDate(1);
  for (let i = 0; i < 12; i++) {
    let start = format(currDate, "MMMyy");
    currDate = subMonths(currDate, 1);
    monthArray.push(`${start}`);
  }
  monthArray.reverse();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedType, setSelectedType] = useState("all");
  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/monthly/account-management-tracking",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          type:selectedType
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  const getdownloadData = () => {
    setDownloadLoader(true);
    try {
      const headers = [["", ...monthArray]];

      // Define rows
      const rows = [
        ["Total Deployed Accounts", ...monthArray.map((item) => data[item]?.deployed_accounts || 0)],
        ["Account Contact Overall"],
        ["Contacted in Last month", ...monthArray.map((item) => data[item]?.last_month_interactions || 0)],
        ["Physically met in Last month", ...monthArray.map((item) => data[item]?.brands_physical_last_month || 0)],
        ["Contacted in last 3 months", ...monthArray.map((item) => data[item]?.brands_in_last_3_months || 0)],
        ["Physically met in 3 months", ...monthArray.map((item) => data[item]?.brands_physical_last_3_months || 0)],
        [`${selectedNewspaper} Advertisers`],
        ["No of clients who advertised with Eenadu", ...monthArray.map((item) => data[item]?.newspaper_brands || 0)],
        ["No of Eenadu exclusive clients", ...monthArray.map((item) => data[item]?.newspaper_unique_brands || 0)],
        ["How many of these were met in last month", ...monthArray.map((item) => data[item]?.newspaper_brands_physical || 0)],
        ["How many of these were met in last 3 months", ...monthArray.map((item) => data[item]?.newspaper_brands_last_3_months || 0)],
      ];
    
      // Create worksheet
      const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Account Management Tracking");
      XLSX.writeFile(workbook, `AccountManagementTracking.xlsx`);
    } catch (error) {
      console.error(error, "AccountManagementTracking");
    } finally {
      setDownloadLoader(false);
    }
  };

  useEffect(() => {
    fetchNewsPapers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedType]);
  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>AccountManagementTracking</h5>
        <aside className="flex gap-3 items-center">
        <SlSelect size="small" value={selectedType} label="Team"  onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
      <table className="table table-bordered mt-2">
        <thead>
          <tr>
            <th></th>
            {monthArray.map((month) => (
              <th>{month}</th>
            ))}
          </tr>
        </thead>
        {!loader && Object.keys(data)?.length > 0 ? <tbody>
          <tr>
            <td>Total Deployed Accounts</td>
            {monthArray.map((item) => (
              <td>{data[item]?.deployed_accounts}</td>
            ))}
          </tr>
          <tr>
            <td>Account Contact Overall</td>
          </tr>
          <tr>
            <td>Contacted in Last month</td>
            {monthArray.map((item) => (
              <td>{data[item]?.last_month_interactions}</td>
            ))}
          </tr>
          <tr>
            <td>Physically met in Last month</td>
            {monthArray.map((item) => (
              <td>{data[item]?.brands_physical_last_month}</td>
            ))}
          </tr>
          <tr>
            <td>Contacted in last 3 months</td>
            {monthArray.map((item) => (
              <td>{data[item]?.brands_in_last_3_months}</td>
            ))}
          </tr>
          <tr>
            <td>Physically met in 3 months</td>
            {monthArray.map((item) => (
              <td>{data[item]?.brands_physical_last_3_months}</td>
            ))}
          </tr>
          <tr>
            <th colSpan={13}>{selectedNewspaper} Advertisers</th>
          </tr>
          <tr>
            <td>No of clients who advertised with Eenadu</td>
            {monthArray.map((item) => (
              <td>{data[item]?.newspaper_brands}</td>
            ))}
          </tr>
          <tr>
            <td>No of Eenadu exclusive clients</td>
            {monthArray.map((item) => (
              <td>{data[item]?.newspaper_unique_brands}</td>
            ))}
          </tr>
          <tr>
            <td>How many of these were met in last month</td>
            {monthArray.map((item) => (
              <td>{data[item]?.newspaper_brands_physical}</td>
            ))}
          </tr>
          <tr>
            <td>How many of these were met in last 3 months</td>
            {monthArray.map((item) => (
              <td>{data[item]?.newspaper_brands_last_3_months}</td>
            ))}
          </tr>
          
          
        </tbody>: loader ? (
        <TableSkelton colspan={13} />
      ) : (
        <NoDataFound colspan={13} />
      )}
      </table>
      </ScrollContainer>
    </>
  );
}

export default AccountManagementTracking;
